import { UserAgencyMapInterface } from '@actassa/api';

export class SelectRole {
    public static readonly type = '[RootState] Select role';

    constructor(public config: UserAgencyMapInterface) { }
}
